import { useCallback, useEffect, useState } from 'react';

export function useResendCountdown(initialSeconds = 0) {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    if (secondsLeft <= 0) return undefined;
    const timer = setInterval(() => {
      setSecondsLeft((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [secondsLeft]);

  const start = useCallback((seconds) => {
    setSecondsLeft(Math.max(0, Number(seconds) || 0));
  }, []);

  return {
    secondsLeft,
    canResend: secondsLeft <= 0,
    start,
  };
}
